var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"range",style:({
      width:_vm.option.width+'px',
      height:_vm.option.height+'px',
  })})])
}
var staticRenderFns = []

export { render, staticRenderFns }